/*
 * File: AppointmentLinks.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 10/11/2018
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Creates the links for the Appointments & Follow-Ups page
 */
import React from "react";
import UILinkList from "components/ui/UILinkList";
import PatientId from "services/patients/store/PatientIdStore";

const AppointmentLinks = () => {
  const patientId = PatientId.getId();
  const patientApptURL = "/patients/" + patientId + "/appointments/";
  const appointmentLinks = [
    {
      primaryString: "Patient Appointments",
      url: patientApptURL + "patient_appointments"
    },
    {
      primaryString: "Follow-Ups",
      url: patientApptURL + "follow-ups"
    }
  ];

  return <UILinkList links={appointmentLinks} />;
};

export default AppointmentLinks;
